import { OrientationType } from "@package/ui-gql/index-data-access";
import { useLayoutEffect, useRef, useState } from "react";
import { type FlyoutProps } from "../../utils/flyout-props";
import { FlyoutPostStateProvider } from "./PostContextProvider/context-flyout-post-provider";
import { FlyoutPostLandscape } from "./PostLandscape";
import { FlyoutPostPortrait } from "./PostPortrait";

export function FlyoutPost({ screen }: FlyoutProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [orientation, setOrientation] = useState<OrientationType>(
    OrientationType.Portrait,
  );

  useLayoutEffect(() => {
    const updateOrientation = () => {
      if (ref.current) {
        setOrientation(
          ref.current.clientWidth > ref.current.clientHeight
            ? OrientationType.Landscape
            : OrientationType.Portrait,
        );
      }
    };

    updateOrientation();

    window.addEventListener("resize", updateOrientation);
    return () => {
      window.removeEventListener("resize", updateOrientation);
    };
  }, []);

  return (
    <FlyoutPostStateProvider screen={screen}>
      <div ref={ref} className="relative h-full w-full">
        {orientation === OrientationType.Portrait && (
          <FlyoutPostPortrait screen={screen} />
        )}
        {orientation === OrientationType.Landscape && (
          <FlyoutPostLandscape screen={screen} />
        )}
      </div>
    </FlyoutPostStateProvider>
  );
}
